// extracted by mini-css-extract-plugin
export var brand = "_ab-9";
export var compact = "_ab-6";
export var extraSmall = "_ab-7";
export var icon = "_ab-0";
export var large = "_ab-4";
export var light = "_ab-1";
export var medium = "_ab-5";
export var outline = "_ab-b";
export var primaryDark = "_ab-a";
export var primaryLight = "_ab-8";
export var primaryModern = "_ab-c";
export var success = "_ab-2";
export var successSolid = "_ab-3";